import { render, staticRenderFns } from "./NotifOwnerRequest.vue?vue&type=template&id=feea5b94&scoped=true"
import script from "./NotifOwnerRequest.vue?vue&type=script&lang=js"
export * from "./NotifOwnerRequest.vue?vue&type=script&lang=js"
import style0 from "./NotifOwnerRequest.vue?vue&type=style&index=0&id=feea5b94&prod&lang=scss&scoped=true"
import style1 from "./NotifStyle.scss?vue&type=style&index=1&id=feea5b94&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feea5b94",
  null
  
)

export default component.exports